<template>
  <div class="pros-email-thanks-page overflow-x-hide tw-bg-[#eeeff0]">
    <div class="container no-padding">
      <headerlogo :page-type="'404'" />

      <div
        class="row no-padding main-body h-100"
        :style="{ height: windowHeight }"
      >
        <div class="col-sm-12 col-md-12 row my-auto no-padding no-margin">
          <div class="col-sm-12 col-12 col-md-12 row no-padding no-margin">
            <div
              class="col-sm-12 col-md-4 offset-md-2 text-container tab-container no-padding flex-container"
            >
              <div class="left-sec align-center">
                <div class="left-sec1">
                  {{ getUiText("app-prospect-email-thanks-heading-1") }}
                </div>
                <div class="left-sec2">
                  {{ subHeading[0] }}
                  <span
                    id="psp-email-thank-verify-email"
                    class="verify-email"
                    >{{ prospectEmail }}</span
                  >
                  {{ subHeading[1] }}
                </div>
                <div class="left-sec3">
                  <span class="left-sec-msg"
                    >{{ getUiText("app-prospect-email-thanks-help-heading-1") }}
                  </span>
                  <span class="left-sec-toggle" @click="toggleShowMore">
                    <img
                      v-if="canShowMore || null"
                      src="@/assets/img/arrow_up.svg"
                    />
                    <img v-else src="@/assets/img/arrow_down.svg" />
                  </span>

                  <div
                    v-if="canShowMore || null"
                    class=""
                    :class="canShowMore ? 'show' : ''"
                  >
                    <div class="toggle-content">
                      <div class="card-body-sec1">
                        {{ getUiText("app-prospect-email-thanks-help-text-1") }}
                      </div>
                      <div class="card-body-sec2">
                        <ul>
                          <li
                            v-for="item in getUiText(
                              'app-prospect-email-thanks-help-text-2',
                              true,
                            )"
                            :key="item"
                          >
                            – {{ item }}
                          </li>
                        </ul>
                      </div>
                      <div class="card-body-sec3">
                        <a
                          href="javascript:void(0);"
                          @click="onClickTryAgain"
                          >{{
                            getUiText("app-prospect-email-thanks-link-action-1")
                          }}</a
                        >
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              class="col-sm-12 col-md-6 tab-image-container flex-container no-padding"
            >
              <brandpattern :page="'EMAILTHANKS'" :top="0" />
              <img src="@/assets/img/bg3.png" class="img-laptop img-mobile" />
            </div>
          </div>
        </div>
      </div>
      <errorhandler
        v-if="showProspectCallbackError || null"
        :prospect-callback-error-msg="prospectCallbackErrorMsg"
        @reset-show-prospect-callback-error="resetShowProspectCallbackError"
      />

      <div
        class="footer row d-sm-none d-md-block d-none d-sm-block page-footer no-margin"
      >
        {{ getUiText("app-prospect-nav-cms-text-1") }}
        <a href="https://cybersystem.io">{{
          getUiText("app-prospect-nav-cms-link-1")
        }}</a>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { Component, Vue, Watch } from "vue-facing-decorator";
import BrandPattern from "@/components/prospect/brandPattern/brandPattern.vue";
import HeaderLogo from "@/components/common/headerLogo.vue";
import Utils from "@/utils/utilities";
import { load } from "recaptcha-v3";
import errorhandler from "@/components/common/exceptionHandler.vue";
import store from "@/store";
import $ from "jquery";
import { localStorageKey } from "@/utils/constants";

// const LanguagePickerModule = namespace('LanguagePicker');

@Component({
  components: {
    headerlogo: HeaderLogo,
    brandpattern: BrandPattern,
    errorhandler,
  },
})
export default class ProspectEmailThanks extends Vue {
  public canShowMore = false;
  public prospectEmail = "";
  public windowHeight = "";
  public showProspectCallbackError = false;
  public prospectCallbackErrorMsg = "";

  public subHeading: any = [];

  get languageSelected() {
    return store.state.LanguagePicker.languageSelected;
  }
  get defaultUiText() {
    return store.state.LanguagePicker.defaultUiText;
  }
  get languageSelectedText() {
    return store.state.LanguagePicker.languageSelectedText;
  }

  created() {
    if (
      sessionStorage.getItem("prospectEmail") !== "" &&
      sessionStorage.getItem("prospectEmail") !== undefined
    ) {
      this.prospectEmail = "" + sessionStorage.getItem("prospectEmail");
      sessionStorage.removeItem("prospectEmail");
      this.setLanguages();
    } else {
      // Redirect to landing page if Email not exists in sessionStorage.
      this.$router.push({ path: "/" });
    }
  }

  mounted() {
    const body = $("body");
    if (!body.hasClass("page-opacity")) {
      body.addClass("page-opacity page-bg");
    }
    window.scrollTo({ top: 1, behavior: "smooth" });

    this.$nextTick(() => {
      window.addEventListener("resize", this.onWindowResize);
      setTimeout(() => {
        this.onWindowResize();
        this.updateUIVariables();
      }, 100);
    });
  }

  @Watch("languageSelected")
  onChangeLanguageSelected() {
    setTimeout(() => {
      this.updateUIVariables();
    }, 50);
  }

  getUiText(id: string, isArray = false) {
    return Utils.getUiText(
      id,
      this.languageSelectedText,
      this.defaultUiText,
      isArray,
    );
  }

  updateUIVariables() {
    this.subHeading = this.getProcessedUIText(
      this.getUiText("app-prospect-email-thanks-heading-sub-1"),
    );
  }

  getProcessedUIText(text: string) {
    let result = text.split("{##prospect.email##}");
    return result;
  }

  async setLanguages() {
    if (
      localStorage.getItem(localStorageKey.languagesData) == null ||
      localStorage.getItem(localStorageKey.languageList) == null
    ) {
      await Utils.getV3Recaptcha().then(
        async (finalKey: any) => {
          const captchKey = finalKey;
          const recaptcha = await load(`${captchKey}`, {
            autoHideBadge: true,
          });
          recaptcha.execute("submit").then((token) => {
            this.$store.dispatch("LanguagePicker/setLanguages", token);
          });
          recaptcha.execute("submit").then((token) => {
            this.$store.dispatch("LanguagePicker/setLanguageList", token);
          });
        },
        (error: any) => {
          if (
            error &&
            error.data &&
            error.data.error &&
            error.data.error.type
          ) {
            if (error.data.error.type === "exc_session_invalid-1") {
              sessionStorage.setItem(
                "prospectCallbackErrorInfo",
                JSON.stringify(error.data.error),
              );
              this.$router.push({ path: "/" });
            } else {
              this.showErrorInfo(error.data.error);
            }
          } else if (error.data.message === "invalid csrf token") {
            sessionStorage.setItem(
              "prospectCallbackErrorInfo",
              JSON.stringify(error.data),
            );
            this.$router.push({ path: "/" });
          } else {
            this.showErrorInfo(error.data);
          }
        },
      );
    }
  }

  showErrorInfo(errorInfo: any) {
    if (errorInfo && errorInfo !== "") {
      errorInfo =
        typeof errorInfo === "string" ? JSON.parse(errorInfo) : errorInfo;
      if (errorInfo && Object.keys(errorInfo).length > 0 && errorInfo.message) {
        this.showProspectCallbackError = true;
        this.prospectCallbackErrorMsg = errorInfo.message;
      }
    }
  }
  resetShowProspectCallbackError() {
    this.showProspectCallbackError = false;
    this.prospectCallbackErrorMsg = "";
  }

  toggleShowMore() {
    this.canShowMore = !this.canShowMore;
    this.onWindowResize();
  }

  onClickTryAgain() {
    this.$router.push({ path: "/" });
  }

  onWindowResize() {
    if (window.innerHeight > 730) {
      if (this.canShowMore) {
        setTimeout(() => {
          if (window.innerHeight > 700) {
            let toggleHeight = $(".left-sec3").height() || 0;
            if (window.innerWidth > 1024) {
              if (window.innerHeight > 1200) {
                this.windowHeight = window.innerHeight - 200 + "px !important";
              } else if (window.innerHeight > 800) {
                this.windowHeight = window.innerHeight - 120 + "px !important";
              } else {
                toggleHeight = toggleHeight - 240;
                this.windowHeight =
                  window.innerHeight - 100 + toggleHeight + "px !important";
              }
            } else {
              this.windowHeight =
                window.innerHeight - 100 + toggleHeight + "px !important";
            }
          } else {
            this.windowHeight = window.innerHeight - 100 + "px !important";
          }
        }, 100);
      } else {
        if (window.innerHeight > 1200 && window.innerHeight < 2500) {
          this.windowHeight = window.innerHeight - 200 + "px !important";
        } else {
          this.windowHeight = window.innerHeight - 120 + "px !important";
        }
      }
    } else {
      if (this.canShowMore) {
        if (window.innerHeight < 800) {
          if (
            window.innerWidth < window.innerHeight ||
            window.innerWidth > window.innerHeight
          ) {
            this.windowHeight = "100% !important";
          } else {
            this.windowHeight = window.innerHeight + 50 + "px !important";
          }
        } else if (window.innerWidth > 1024) {
          this.windowHeight = window.innerHeight + "px !important";
        } else {
          this.windowHeight = "100% !important";
        }
      } else {
        this.windowHeight = "100% !important";
      }
    }
  }

  beforeUnmount() {
    const body = $("body");
    if (!body.hasClass("page-opacity")) {
      body.addClass("page-opacity page-bg");
    }
  }
}
</script>
<style lang="scss" scoped>
.left-sec1 {
  font-style: normal;
  font-weight: 500;
  font-size: 42px;
  line-height: 140%;
  display: flex;
  align-items: flex-end;
  color: #231f20;
}

.left-sec2 {
  margin-top: 26px;
  position: relative;
  font-style: normal;
  font-weight: normal;
  font-size: 22px;
  line-height: 170%;
  color: #231f20;
  word-wrap: break-word;

  .verify-email {
    font-weight: 500;
    word-wrap: break-word;
  }
}
.left-sec3 {
  margin-top: 44px;
  position: relative;
  font-style: normal;
  font-weight: 500;
  font-size: 15px;
  line-height: 22px;
  color: #231f20;

  .toggle-content {
    margin-top: 14px;
    position: relative;
  }
  .card-body-sec1 {
    font-style: normal;
    font-weight: normal;
    font-size: 15px;
    line-height: 22px;
    color: #231f20;
  }
  .card-body-sec2 {
    margin-top: 20px;
    position: relative;
    font-style: normal;
    font-weight: normal;
    font-size: 15px;
    line-height: 22px;
    color: #231f20;

    ul {
      list-style-type: none;
      padding-left: 0;
    }
  }
  .card-body-sec3 {
    margin-top: 40px;
    position: relative;
    a {
      text-decoration: underline;
    }
  }
}
.left-sec-toggle {
  cursor: pointer;

  img {
    padding-left: 6px;
  }
}
.text-container,
.page-footer {
  z-index: 1;
}
</style>
